/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LacTotalsResponseRowPaginatorResponse } from '../../models/lac-totals-response-row-paginator-response';
import { LacTotalsSearchRequest } from '../../models/lac-totals-search-request';

export interface PostFeV1LacTotals$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
      body?: LacTotalsSearchRequest
}

export function postFeV1LacTotals$Plain(http: HttpClient, rootUrl: string, params?: PostFeV1LacTotals$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LacTotalsResponseRowPaginatorResponse>> {
  const rb = new RequestBuilder(rootUrl, postFeV1LacTotals$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LacTotalsResponseRowPaginatorResponse>;
    })
  );
}

postFeV1LacTotals$Plain.PATH = '/v1/lac-totals';
